import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import { routes } from "../constants/routes";
import Swal from "sweetalert2";
import CustomModal from "../components/Modal/Modal";
import Login from "../auth/Login";
import SignUp from "../auth/SignUp";
import ForgotPassword from "../auth/ForgotPassword";
import { useDispatch, useSelector } from "react-redux";
import { injectModels } from "../redux/injectModels";
import ResetPassword from "../auth/ResetPassword";
import ChangePassword from "../auth/ChangePassword";
import * as CONSTANTS from "../redux/Models/Application/constants";
import { AuthService } from "../services";
import Avatar from "../components/Image/AvatarPreview";
import { globalConstant } from "../constants/globalConstant";
import HeaderLogo from "../components/Logo/HeaderLogo";
import { Routes } from "../constants";
import { UserRoleType } from "../constants/Enum";
import { NotificationService } from "../services";
import {
  getGroupMessagesThread,
  getMessageThreadFrom,
  getMessageThreadTo,
} from "../services/FirebaseStorage";
import { handleConsoleError } from "../utils/common-methods";
// import PaymentCard from "../../../Common/PaymentCard";
function Header(props) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isModalOpen, setModalOpen] = useState(false);
  const [isLogin, setLoginStatus] = useState(false);
  const loginUser = AuthService.getLoginUser();
  const currentModel = useSelector((state) => state?.application?.currentModel);
  const [unreadCount, setUnreadCount] = useState();
  const [isUnread, setUnread] = useState(false);
  const [isGroupUnread, setGroupUnread] = useState(false);
  const [returnUrl, setloginUrl] = useState(null);

  useEffect(() => {
    setloginUrl(localStorage.getItem("loginUrl") || null);
    if (!loginUser) {
      setLoginStatus(false);
      if (returnUrl) {
        localStorage.setItem("returnUrl", returnUrl);
        localStorage.removeItem("loginUrl");
        setloginUrl(null);
        dispatch({
          type: CONSTANTS.SET_CURRENT_MODAL,
          payload: CONSTANTS.LOGIN_MODAL,
        });
      }
    } else {
      setLoginStatus(true);
    }

    if (currentModel !== "") {
      setModalOpen(true);
    } else {
      setModalOpen(false);
    }

    getUnreadMessageCount();
  }, [loginUser, currentModel]);

//   // Safe navigation helper
// const safeGet = (obj, path, defaultValue = null) => {
//   try {
//     return path.split('.').reduce((acc, part) => acc?.[part], obj) ?? defaultValue;
//   } catch (error) {
//     console.error("Safe navigation error:", error);
//     return defaultValue;
//   }
// };

// Helper function to check if thread has unread messages
const hasUnreadMessages = (thread, loginUserId, isGroup = false) => {
  if (!thread || !loginUserId) return false;
  
  if (!thread?.lastRead) return false;
  
  const userLastRead = thread.lastRead[loginUserId];
  if (!userLastRead?.seconds) return false;
  
  if (isGroup) {
    // Group message unread check
    if (!thread.users || !Array.isArray(thread.users)) return false;
    
    return thread.users.some(user => {
      if (user === loginUserId) return false;
      
      const otherUserLastRead = thread.lastRead[user];
      if (!otherUserLastRead?.seconds) return false;
      
      return userLastRead.seconds < otherUserLastRead.seconds &&
             userLastRead.seconds !== otherUserLastRead.seconds;
    });
  } else {
    // Individual message unread check
    const otherUserId = loginUserId === thread.createdBy 
      ? thread.toUser 
      : thread.createdBy;
    
    if (!otherUserId) return false;
    
    const otherUserLastRead = thread.lastRead[otherUserId];
    if (!otherUserLastRead?.seconds) return false;
    
    const createdByLastRead = thread.lastRead[thread.createdBy];
    const toUserLastRead = thread.lastRead[thread.toUser];
    
    return userLastRead.seconds < otherUserLastRead.seconds &&
           createdByLastRead?.seconds !== toUserLastRead?.seconds;
  }
};

//handle message thread
useEffect(() => {
  let unsubscribeFrom = null;
  let unsubscribeTo = null;
  
  const bootstrapAsync = async () => {
    try {
      // Validate login user
      if (!loginUser?.id) {
        console.warn("No login user found for message thread");
        return;
      }
      
      // Get message threads from "from" direction
      unsubscribeFrom = await getMessageThreadFrom(
        loginUser.id,
        async (threadData1) => {
          // Validate thread data
          if (!threadData1 || !Array.isArray(threadData1)) {
            console.warn("Invalid thread data from getMessageThreadFrom");
            return;
          }
          
          // Get message threads from "to" direction
          unsubscribeTo = await getMessageThreadTo(
            loginUser.id,
            async (threadData2) => {
              // Validate thread data
              if (!threadData2 || !Array.isArray(threadData2)) {
                console.warn("Invalid thread data from getMessageThreadTo");
                return;
              }
              
              // Combine threads
              const messageThreads = [...threadData1, ...threadData2];
              
              if (messageThreads.length === 0) {
                setUnread(false);
                return;
              }
              
              // Check for unread messages
              let isUnreadFound = false;
              
              for (const thread of messageThreads) {
                if (hasUnreadMessages(thread, loginUser.id, false)) {
                  isUnreadFound = true;
                  break;
                }
              }
              
              setUnread(isUnreadFound);
            }
          );
        }
      );
    } catch (error) {
      console.error("ERROR in message thread initialization: ", error);
      setUnread(false);
    }
  };
  
  // Execute bootstrap
  if (loginUser?.id) {
    bootstrapAsync();
  }
  
  // Cleanup function
  return () => {
    if (unsubscribeFrom && typeof unsubscribeFrom === 'function') {
      unsubscribeFrom();
    }
    if (unsubscribeTo && typeof unsubscribeTo === 'function') {
      unsubscribeTo();
    }
  };
}, [loginUser?.id]); // Add dependency

//handle group messages thread
useEffect(() => {
  let unsubscribe = null;
  
  const bootstrapAsync = async () => {
    try {
      // Validate login user
      if (!loginUser?.id) {
        console.warn("No login user found for group messages");
        return;
      }
      
      // Get group message threads
      unsubscribe = await getGroupMessagesThread(
        loginUser.id,
        async (threadData) => {
          // Validate thread data
          if (!threadData || !Array.isArray(threadData)) {
            console.warn("Invalid group thread data");
            setGroupUnread(false);
            return;
          }
          
          if (threadData.length === 0) {
            setGroupUnread(false);
            return;
          }
          
          // Check for unread messages in group threads
          let isUnreadFound = false;
          
          for (const thread of threadData) {
            if (!thread?.lastRead || !thread?.users) continue;
            
            if (hasUnreadMessages(thread, loginUser.id, true)) {
              isUnreadFound = true;
              break;
            }
          }
          
          setGroupUnread(isUnreadFound);
        }
      );
    } catch (error) {
      console.error("ERROR in group message thread initialization: ", error);
      setGroupUnread(false);
    }
  };
  
  // Execute bootstrap
  if (loginUser?.id) {
    bootstrapAsync();
  }
  
  // Cleanup function
  return () => {
    if (unsubscribe && typeof unsubscribe === 'function') {
      unsubscribe();
    }
  };
}, [loginUser?.id]); // Add dependency

// Helper function for error handling
const handleConsoleError = (error) => {
  if (!error) return "An unknown error occurred";
  
  if (typeof error === 'string') return error;
  
  if (error.message) return error.message;
  
  if (error.toString) return error.toString();
  
  return "Something went wrong";
};

//for unread message count
const getUnreadMessageCount = async () => {
  // Validate login user
  if (!loginUser?.id) {
    console.warn("Cannot get unread message count: No login user");
    return;
  }
  
  const userId = loginUser.id;
  
  try {
    const res = await NotificationService.getNotificationUnreadMessageCount(userId);
    
    // Validate response
    if (!res) {
      console.warn("Empty response from getNotificationUnreadMessageCount");
      setUnreadCount(0);
      return;
    }
    
    if (res?.isSuccess === true) {
      const count = res?.data?.countOfUnreadMessages;
      setUnreadCount(typeof count === 'number' ? count : 0);
    } else {
      // Handle error response without showing toast for every error
      const errorMessage = res?.message || 
                          res?.Errors?.[0]?.Message || 
                          "Failed to fetch unread message count";
      console.warn("Error fetching unread count:", errorMessage);
      setUnreadCount(0);
    }
  } catch (error) {
    const message = handleConsoleError(error);
    console.error("Exception in getUnreadMessageCount:", message);
    
    // Only show toast for critical errors, not for every failure
    if (error?.code === 'NETWORK_ERROR' || error?.status === 500) {
      toast.error("Unable to fetch unread messages. Please check your connection.");
    }
    
    setUnreadCount(0);
  }
};

// Optional: Create a combined effect for better performance
useEffect(() => {
  let isMounted = true;
  
  const initializeMessageThreads = async () => {
    if (!loginUser?.id) return;
    
    try {
      // Run both thread initializations
      await Promise.all([
        // This would require refactoring the above effects to be callable
        // For now, keep them separate or create a unified function
      ]);
    } catch (error) {
      console.error("Error initializing message threads:", error);
    }
  };
  
  if (loginUser?.id) {
    initializeMessageThreads();
  }
  
  return () => {
    isMounted = false;
  };
}, [loginUser?.id]);

// Optional: Create a periodic refresh for unread counts (every 30 seconds)
useEffect(() => {
  if (!loginUser?.id) return;
  
  // Initial fetch
  getUnreadMessageCount();
  
  // Set up interval for periodic refresh
  const intervalId = setInterval(() => {
    getUnreadMessageCount();
  }, 30000); // Refresh every 30 seconds
  
  // Cleanup interval on unmount
  return () => {
    if (intervalId) {
      clearInterval(intervalId);
    }
  };
}, [loginUser?.id]);

  const closeModal = () => {
    localStorage.removeItem("returnUrl");
    dispatch({
      type: CONSTANTS.SET_CURRENT_MODAL,
      payload: CONSTANTS.CLEAR_MODAL,
    });
  };

  const handleSignOut = () => {
    const pinkColor = globalConstant.COLOR_PINK;
    Swal.fire({
      title: "Confirmation",
      text: "Are you sure you want to Logout?",
      showCancelButton: true,
      confirmButtonColor: pinkColor,
      cancelButtonColor: "#373737",
      confirmButtonText: `Yes`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          let email = localStorage.getItem("RememberMeEmail");
          let password = localStorage.getItem("Password");
         
          await props.auth.logout();
          localStorage.clear();
          setloginUrl(null);
           
          if (email != null && password != null) {
            localStorage.setItem("RememberMeEmail", email);
            localStorage.setItem("Password", password);
          }
          try{
            await AuthService.SignOut();
          }
          catch(error)
          {

          }
          
          toast.success("Sign out successfully!");
          navigate(routes.DEFAULT);
        } catch (err) {
          const message = handleConsoleError(err);
          toast.error(err?.message||message);
          //return Promise.reject(err);
        }
      }
    });
  };

  const handleLogin = () => {
    dispatch({
      type: CONSTANTS.SET_CURRENT_MODAL,
      payload: CONSTANTS.LOGIN_MODAL,
    });
  };
  const handleSignup = () => {
    dispatch({
      type: CONSTANTS.SET_CURRENT_MODAL,
      payload: CONSTANTS.SIGNUP_MODAL,
    });
  };

  const handleChangePassword = () => {
    dispatch({
      type: CONSTANTS.SET_CURRENT_MODAL,
      payload: CONSTANTS.CHANGE_PASSWORD,
    });
  };

  return (
    <React.Fragment>
      <CustomModal isOpen={isModalOpen} onClose={closeModal}>
        {currentModel === CONSTANTS.LOGIN_MODAL && <Login></Login>}
        {currentModel === CONSTANTS.FORGET_MODAL && (
          <ForgotPassword></ForgotPassword>
        )}
        {currentModel === CONSTANTS.RESET_MODAL && (
          <ResetPassword></ResetPassword>
        )}
        {currentModel === CONSTANTS.CHANGE_PASSWORD && (
          <ChangePassword></ChangePassword>
        )}
        {currentModel === CONSTANTS.SIGNUP_MODAL && <SignUp></SignUp>}
      </CustomModal>

      <section className="swallow-nav">
        <section className="navigation">
          <div className="nav-container">
            <div className="brand">
              {/* <Link to="https://www.swallowevents.com">
                <HeaderLogo></HeaderLogo>
              </Link> */}
               <a
                          href={"https://www.swallowevents.com/"}
                          target="_self"
                          rel="noreferrer"
                        >
 <HeaderLogo></HeaderLogo>
                        </a>
                       
            </div>
            <nav>
              <div className="nav-mobile">
                <a id="navbar-toggle" href="#!">
                  <span></span>
                </a>
              </div>
              <div className="mb-latest">
                <ul className="nav-list">
                  <li key="organize-desktop" className="origanies1 one">
                    <a href="#!">
                      Organise <i className="fa-solid fa-angle-down"></i>
                    </a>
                    <ul className="navbar-dropdown">
                      <div className="row">
                        <div className="col-sm-12 col-md-6 col-lg-6 artist-vebder">
                          <ul className="tools-heading2">
                            <h3 className="tools-heading1">
                              Event Management Tools
                            </h3>
                            <li key="catering-management">
                              <a
                                onClick={() => {
                                  if (!isLogin) {
                                    dispatch({
                                      type: CONSTANTS.SET_CURRENT_MODAL,
                                      payload: CONSTANTS.LOGIN_MODAL,
                                    });
                                    return;
                                  }
                                  navigate(Routes.ACCOUNT_DASHBOARD);
                                }}
                                href="#!"
                                // target="_blank"
                                // rel="noreferrer"
                              >
                                <i className="fa-solid fa-angles-right"></i>{" "}
                                Catering And Retail Trade Stands Management
                              </a>
                            </li>
                            <li key="event-hardware">
                              <a
                                onClick={() => {
                                  if (!isLogin) {
                                    dispatch({
                                      type: CONSTANTS.SET_CURRENT_MODAL,
                                      payload: CONSTANTS.LOGIN_MODAL,
                                    });
                                    return;
                                  }
                                  navigate(Routes.ACCOUNT_DASHBOARD);
                                }}
                                href="https://www.swallowevents.com/event-wifi-electronic-point-of-sale"
                                target="_blank"
                                rel="noreferrer"
                              >
                                <i className="fa-solid fa-angles-right"></i>{" "}
                                Event Hardware Solutions
                              </a>
                            </li>
                            <li key="ticketing">
                              <a
                                onClick={() => {
                                  if (!isLogin) {
                                    dispatch({
                                      type: CONSTANTS.SET_CURRENT_MODAL,
                                      payload: CONSTANTS.LOGIN_MODAL,
                                    });
                                    return;
                                  }
                                  navigate(Routes.ACCOUNT_DASHBOARD);
                                }}
                                href="#!"
                              >
                                <i className="fa-solid fa-angles-right"></i>{" "}
                                Ticketing & Registration
                              </a>
                            </li>
                          </ul>
                        </div>
                        <div className="col-sm-12 col-md-6 col-lg-6">
                          <ul className="tools-heading2">
                            <h3 className="tools-heading1">
                              About Swallow Events
                            </h3>
                            <li key="company-overview">
                              <a
                                 href="https://www.swallowevents.com/leadership-team"
                                target="_blank"
                                rel="noreferrer"
                              >
                                <i className="fa-solid fa-angles-right"></i>{" "}
                                Company Overview
                              </a>
                            </li>
                            <li key="pricing">
                              <a href={Routes.PRICING}>
                                <i className="fa-solid fa-angles-right"></i>{" "}
                                Pricing
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </ul>
                  </li>

                  <li key="participate-desktop" className="origanies1">
                    <a href="#!">
                      Participate <i className="fa-solid fa-angle-down"></i>
                    </a>
                    <ul className="navbar-dropdown">
                      <div className="row">
                        <div className="col-sm-12 col-md-6 col-lg-6 artist-vebder">
                          <ul className="tools-heading2">
                            <h3 className="tools-heading1">
                              Catering & Retail Trade Stands
                            </h3>
                            {loginUser === null ||
                            (loginUser &&
                              loginUser?.role === UserRoleType.MOBILECATERERS) ||
                            loginUser?.role === UserRoleType.TRADERRETAILER ? (
                              <li key="your-applications">
                                <a
                                  onClick={(e) => {
                                    e.preventDefault();
                                    if (!isLogin) {
                                      dispatch({
                                        type: CONSTANTS.SET_CURRENT_MODAL,
                                        payload: CONSTANTS.LOGIN_MODAL,
                                      });
                                      return;
                                    }
                                    navigate(Routes.ACCOUNT_APPLICATIONS);
                                  }}
                                  href="#!"
                                >
                                  <i className="fa-solid fa-angles-right"></i>{" "}
                                  Your Applications
                                </a>
                              </li>
                            ) : (
                              <></>
                            )}

                            <li key="create-shop-front">
                              <a
                                onClick={(e) => {
                                  e.preventDefault();
                                  if (!isLogin) {
                                    dispatch({
                                      type: CONSTANTS.SET_CURRENT_MODAL,
                                      payload: CONSTANTS.LOGIN_MODAL,
                                    });
                                    return;
                                  }
                                  navigate(Routes.TRADER_UNIT_LIST);
                                }}
                                href="#!"
                              >
                                <i className="fa-solid fa-angles-right"></i>{" "}
                                Create A Shop Front
                              </a>
                            </li>
                            <li key="view-sales">
                              <a
                                onClick={(e) => {
                                  e.preventDefault();
                                  if (!isLogin) {
                                    dispatch({
                                      type: CONSTANTS.SET_CURRENT_MODAL,
                                      payload: CONSTANTS.LOGIN_MODAL,
                                    });
                                    return;
                                  }
                                  navigate(Routes.USER);
                                }}
                                href="#!"
                              >
                                <i className="fa-solid fa-angles-right"></i>{" "}
                                View Your Sales
                              </a>
                            </li>
                          </ul>
                        </div>
                        <div className="col-sm-12 col-md-6 col-lg-6">
                          <ul className="tools-heading2">
                            <h3 className="tools-heading1">
                              Ticket Attendees/Buyers
                            </h3>
                            <li key="your-tickets">
                              <a
                                onClick={(e) => {
                                  e.preventDefault();
                                  if (!isLogin) {
                                    dispatch({
                                      type: CONSTANTS.SET_CURRENT_MODAL,
                                      payload: CONSTANTS.LOGIN_MODAL,
                                    });
                                    return;
                                  }
                                  navigate(Routes.ACCOUNT_DASHBOARD);
                                }}
                                href="#!"
                              >
                                <i className="fa-solid fa-angles-right"></i>{" "}
                                Your Tickets
                              </a>
                            </li>
                            <li key="your-orders">
                              <a
                                onClick={(e) => {
                                  e.preventDefault();
                                  if (!isLogin) {
                                    dispatch({
                                      type: CONSTANTS.SET_CURRENT_MODAL,
                                      payload: CONSTANTS.LOGIN_MODAL,
                                    });
                                    return;
                                  }
                                  navigate(Routes.ACCOUNT_DASHBOARD);
                                }}
                                href="#!"
                              >
                                <i className="fa-solid fa-angles-right"></i>{" "}
                                Your Orders
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </ul>
                  </li>
                </ul>
                <ul className="nav-list">
                  <li key="organize-mobile" className="origanies1 mobile1 one">
                    <a href="#!">
                      Organise <i className="fa-solid fa-angle-down"></i>
                    </a>
                    <ul className="navbar-dropdown">
                      <h3 key="mobile-event-tools-title" className="tools-heading1">Event Management Tools</h3>
                      <li key="mobile-catering-management">
                        <a
                          onClick={(e) => {
                            e.preventDefault();
                            if (!isLogin) {
                              dispatch({
                                type: CONSTANTS.SET_CURRENT_MODAL,
                                payload: CONSTANTS.LOGIN_MODAL,
                              });
                              return;
                            }
                            navigate(Routes.ACCOUNT_DASHBOARD);
                          }}
                          href="#!"
                        >
                          <i className="fa-solid fa-angles-right"></i> Catering
                          And Retail Trade Stands Management
                        </a>
                      </li>
                      <li key="mobile-event-hardware">
                        <a
                          onClick={(e) => {
                            e.preventDefault();
                            if (!isLogin) {
                              dispatch({
                                type: CONSTANTS.SET_CURRENT_MODAL,
                                payload: CONSTANTS.LOGIN_MODAL,
                              });
                              return;
                            }
                            navigate(Routes.ACCOUNT_DASHBOARD);
                          }}
                          href="https://www.swallowevents.com/event-wifi-electronic-point-of-sale"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <i className="fa-solid fa-angles-right"></i> Event
                          Hardware Solutions
                        </a>
                      </li>
                      <li key="mobile-ticketing">
                        <a
                          onClick={(e) => {
                            e.preventDefault();
                            if (!isLogin) {
                              dispatch({
                                type: CONSTANTS.SET_CURRENT_MODAL,
                                payload: CONSTANTS.LOGIN_MODAL,
                              });
                              return;
                            }
                            navigate(Routes.ACCOUNT_DASHBOARD);
                          }}
                          href="#!"
                        >
                          <i className="fa-solid fa-angles-right"></i> Ticketing
                          & Registration
                        </a>
                      </li>
                      <h3 className="tools-heading1">About Swallow Events</h3>
                      <li key="mobile-company-overview">
                        <a
                          href={"https://www.swallowevents.com/"}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <i className="fa-solid fa-angles-right"></i> Company
                          Overview
                        </a>
                      </li>
                      <li key="mobile-pricing">
                        <a href={Routes.PRICING}>
                          <i className="fa-solid fa-angles-right"></i> Pricing
                        </a>
                      </li>
                    </ul>
                  </li>

                  <li  key="participate-mobile" className="origanies1 mobile1">
                    <a href="#!">
                      Participate <i className="fa-solid fa-angle-down"></i>
                    </a>
                    <ul className="navbar-dropdown">
                      <h3 className="tools-heading1">
                        Catering & Retail Trade Stands
                      </h3>

                      {loginUser === null ||
                      (loginUser &&
                        loginUser?.role === UserRoleType.MOBILECATERERS) ||
                      loginUser?.role === UserRoleType.TRADERRETAILER ? (
                        <li key="mobile-your-applications">
                          <a
                            onClick={(e) => {
                              e.preventDefault();
                              if (!isLogin) {
                                dispatch({
                                  type: CONSTANTS.SET_CURRENT_MODAL,
                                  payload: CONSTANTS.LOGIN_MODAL,
                                });
                                return;
                              }
                              navigate(Routes.ACCOUNT_APPLICATIONS);
                            }}
                            href="#!"
                          >
                            <i className="fa-solid fa-angles-right"></i> Your
                            Applications
                          </a>
                        </li>
                      ) : (
                        <></>
                      )}

                      <li key="mobile-create-shop">
                        <a
                          onClick={(e) => {
                            e.preventDefault();
                            if (!isLogin) {
                              dispatch({
                                type: CONSTANTS.SET_CURRENT_MODAL,
                                payload: CONSTANTS.LOGIN_MODAL,
                              });
                              return;
                            }
                            navigate(Routes.ACCOUNT_DASHBOARD);
                          }}
                          href="#!"
                        >
                          <i className="fa-solid fa-angles-right"></i> Create A
                          Shop Front
                        </a>
                      </li>
                      <li key="mobile-view-sales">
                        <a
                          onClick={(e) => {
                            e.preventDefault();
                            if (!isLogin) {
                              dispatch({
                                type: CONSTANTS.SET_CURRENT_MODAL,
                                payload: CONSTANTS.LOGIN_MODAL,
                              });
                              return;
                            }
                            navigate(Routes.ACCOUNT_DASHBOARD);
                          }}
                          href="#!"
                        >
                          <i className="fa-solid fa-angles-right"></i> View Your
                          Sales
                        </a>
                      </li>

                      <h3 key="mobile-tickets-title" className="tools-heading1">
                        Ticket Attendees/Buyers
                      </h3>
                      <li key="mobile-your-tickets">
                        <a href="#!">
                          <i className="fa-solid fa-angles-right"></i> Your
                          Tickets
                        </a>
                      </li>
                      <li key="mobile-your-orders">
                        <a href="#!">
                          <i className="fa-solid fa-angles-right"></i> Your
                          Orders
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li key="home">
                    {/* <Link to={routes.DEFAULT}>Home</Link> */}
                     <a
                      href={routes.DEFAULT}
                      target="_self"
                      rel="noopener noreferrer"
                    >                      Home
                    </a>
                  </li>
                  <li key="event-management">
                    <a
                      href="https://www.swallowevents.com/event-management"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Event & Brand Management
                    </a>
                  </li>
                  <li key="in-the-press">
                    <a
                      href="https://www.swallowevents.com/covid19-testing-and-compliance"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      In The Press
                    </a>
                  </li>

                  <li key="leadership-team">
                    <a
                      href="https://www.swallowevents.com/leadership-team"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Leadership Team
                    </a>
                  </li>
                  <li key="more">
                    <a href="#!">
                      More <i className="fa-solid fa-angle-down"></i>
                    </a>
                    <ul className="navbar-dropdown more">
                      <li key="contact">
                        <a
                          href="https://www.swallowevents.com/contact"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Contact
                        </a>
                      </li>
                      <li key="airstream-caterers">
                        <a
                          href="https://www.swallowevents.com/airstream-catering"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Airstream Caterers
                        </a>
                      </li>
                      <li key="airstream-hire">
                        <a
                          href="https://www.swallowevents.com/airstream-hire"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Airstream Hire & Sales
                        </a>
                      </li>
                           {/* <li key="blog">
                        <a
                          href="https://www.swallowevents.com/blog"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Blog
                        </a>
                      </li> */}
                    </ul>
                  </li>

                  {isLogin && loginUser && (
                    <li key="notifications">
                      <Link to={routes.NOTIFICATION_LIST} className="me-3">
                        <i className="fa-solid fa-bell text-xl"></i>
                        {unreadCount > 0 && (
                          <span
                            className="position-absolute"
                            style={{ marginTop: "-10px", left: "21px" }}
                          >
                            {unreadCount}
                          </span>
                        )}
                      </Link>
                    </li>
                  )}

                  {isLogin && loginUser && (
                    <li key="account-dropdown" className="account-drop">
                      <div className="dropdown">
                        <button className="more">
                          <Avatar
                            imageUrl={loginUser?.profileUrl}
                            altText={loginUser?.firstName?.toUpperCase()[0]}
                            size={36}
                            borderColor={globalConstant.COLOR_LITE}
                            backgroundColor={globalConstant.COLOR_LITE}
                            borderWidth={globalConstant.BOARDER_THIN}
                          />
                          {/* <img src="/assets/images/account-log.png" alt="" />{" "} */}
                          Logged in as{" "}
                          <span>
                            {loginUser?.firstName} {loginUser?.lastName}
                            <i className="fa-solid fa-angle-down"></i>
                          </span>
                        </button>

                        <ul className="dropdown-menu">
                          <li>
                            <Link to={routes.ACCOUNT_PERSONALINFO}>
                              <i className="fa-regular fa-user"></i> View
                              profile
                            </Link>
                          </li>
                          <li>
                            <Link to={routes.ACCOUNT_DASHBOARD}>
                              <i className="fa-solid fa-gear"></i> Account
                              settings
                            </Link>
                          </li>

                          {/* <li>
                            <Link to={routes.CHANGEPASSWORD}>
                            <i className="fa-solid fa-lock"></i>   Change Password
                            </Link>
                          </li> */}

                          <li>
                            <a href="#!" onClick={handleChangePassword}>
                              <i className="fa-solid fa-lock"></i> Change
                              Password
                            </a>
                          </li>

                          <li>
                            <Link to={routes.MESSAGE_INBOX}>
                              <i className="fa-solid fa-comment"></i> Messages{" "}
                              {isUnread || isGroupUnread ? (
                                <span className="message-active"></span>
                              ) : (
                                <></>
                              )}
                            </Link>
                          </li>

                          {/* <li>
                            <Link to={routes.ACCOUNT_BUSINESSINFO}>
                              <i className="fa-regular fa-message"></i> Messages
                            </Link>
                          </li> */}
                          <li>
                            <a href="#!" onClick={handleSignOut}>
                              <i className="fa-solid fa-right-from-bracket"></i>{" "}
                              Logout
                            </a>
                          </li>
                        </ul>
                      </div>
                    </li>
                  )}
                  {!isLogin && (
                    <li key="signup" className="login1">
                      <a
                        href="#!"
                        onClick={handleLogin}
                        // data-bs-toggle="modal"
                        // data-bs-target="#staticBackdrop"
                      >
                        Login <img src="/assets/images/nav-icon1.png" alt="" />
                      </a>
                    </li>
                  )}
                  {!isLogin && (
                    <li  key="signup2" className="login2">
                      <a href="#!" onClick={handleSignup}>
                        Sign up{" "}
                        <img src="/assets/images/nav-icon2.png" alt="" />
                      </a>
                    </li>
                  )}
                </ul>
              </div>
            </nav>
          </div>
        </section>
      </section>
    </React.Fragment>
  );
}

export default injectModels(["application", "auth"])(Header);
